import { render, staticRenderFns } from "./PaginaAltreSpese.vue?vue&type=template&id=3c13e5d6"
import script from "./PaginaAltreSpese.vue?vue&type=script&lang=js"
export * from "./PaginaAltreSpese.vue?vue&type=script&lang=js"
import style0 from "./PaginaAltreSpese.vue?vue&type=style&index=0&id=3c13e5d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports